import React, { createContext, useContext, useState } from 'react'

export const CURRENCIES = [
  { code: 'USD', symbol: '$',   name: 'US Dollar',         flag: '🇺🇸' },
  { code: 'EUR', symbol: '€',   name: 'Euro',              flag: '🇪🇺' },
  { code: 'INR', symbol: '₹',   name: 'Indian Rupee',      flag: '🇮🇳' },
  { code: 'GBP', symbol: '£',   name: 'British Pound',     flag: '🇬🇧' },
  { code: 'JPY', symbol: '¥',   name: 'Japanese Yen',      flag: '🇯🇵' },
  { code: 'CNY', symbol: 'CN¥', name: 'Chinese Yuan',      flag: '🇨🇳' },
  { code: 'CAD', symbol: 'C$',  name: 'Canadian Dollar',   flag: '🇨🇦' },
  { code: 'AUD', symbol: 'A$',  name: 'Australian Dollar', flag: '🇦🇺' },
  { code: 'CHF', symbol: 'Fr',  name: 'Swiss Franc',       flag: '🇨🇭' },
  { code: 'SGD', symbol: 'S$',  name: 'Singapore Dollar',  flag: '🇸🇬' },
  { code: 'AED', symbol: 'AED', name: 'UAE Dirham',        flag: '🇦🇪' },
  { code: 'BRL', symbol: 'R$',  name: 'Brazilian Real',    flag: '🇧🇷' },
]

const CurrencyContext = createContext({
  currency: CURRENCIES[0],
  setCurrency: () => {},
})

export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState(() => {
    try {
      const saved = localStorage.getItem('sn_currency')
      return CURRENCIES.find(c => c.code === saved) || CURRENCIES[0]
    } catch {
      return CURRENCIES[0]
    }
  })

  const setCurrency = c => {
    setCurrencyState(c)
    try { localStorage.setItem('sn_currency', c.code) } catch {}
  }

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  )
}

export function useCurrency() {
  return useContext(CurrencyContext)
}
